import { PriceBreakdown } from '../api/booking/pricePreviewApiTypes';

/**
 * Whether a saved booking's price carries an admin's price adjustment (#3421):
 * a discount or surcharge set on the booking, not a redeemed code or a prepaid
 * voucher. Only then does the invoice offer to fold it into the line prices.
 */
export const hasPriceAdjustment = (breakdown: Pick<PriceBreakdown, 'discount' | 'reduction'> | null | undefined): boolean =>
    breakdown?.reduction?.kind === 'adjustment' && breakdown.discount !== 0;
